/**
 * A new admin link, made on this phone. The server sends the new link only to the phone that
 * asked for it and drops every other admin screen, so this page's own address now holds a dead
 * token: at its next reconnect it would be locked out too. This works out where to move to.
 */

/** The token in an admin link ("https://host/a/<token>?t=x"), or null. */
export function adminToken(link: string): string | null {
  try {
    const [kind, token] = new URL(link, "https://x.invalid").pathname.split("/").filter(Boolean);
    return kind === "a" && token ? token : null;
  } catch {
    return null;
  }
}

/**
 * This page's address with only the token swapped for the one in `link`: same tab, same query.
 * Null when there is nothing to do (no link, the same token, or an address without the token).
 */
export function addressAfterNewLink(here: { pathname: string; search: string; hash: string }, ownToken: string, link: string): string | null {
  const token = adminToken(link);
  if (!token || token === ownToken) return null;
  const parts = here.pathname.split("/");
  const at = parts.indexOf(ownToken);
  if (at < 0) return null;
  parts[at] = token;
  return parts.join("/") + here.search + here.hash;
}
